import React from 'react';
import { ComponentType } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { Navbar } from 'react-bootstrap';

import './CountDownTimer.css';

interface CountdownTimerProps {
    timeLeftInMin?: number | null;
    timeoutFunction: () => void;
}

interface CountdownTimerState {
    timeLeft: number; // in minutes
    stopDateTime: Date;
}

class CountdownTimer extends React.Component<CountdownTimerProps, CountdownTimerState> {

    static readonly TIME_LEFT_DEFAULT: number = 20 * 60; // 20 minutes in second

    private timer: NodeJS.Timeout | null = null;

    constructor(props: CountdownTimerProps) {
        super(props);

        let timeLeftInMin = props.timeLeftInMin;
        var stopDateTime = new Date(new Date().getTime() + (timeLeftInMin ? timeLeftInMin * 60 * 1000 : 0));
        this.state = {
            timeLeft: timeLeftInMin ? (timeLeftInMin * 60) : CountdownTimer.TIME_LEFT_DEFAULT,
            stopDateTime: stopDateTime,
        };
    }

    componentDidMount() {
        // having the scheduler to update the time on screen every 1000 millisecond
        this.timer = setInterval(() => {
            this.setState((prevState) => {
                var now = new Date().getTime();
                var timeToStop = prevState.stopDateTime.getTime() - now;
                if (timeToStop <= 1) {
                    if (this.timer) clearInterval(this.timer);
                    this.props.timeoutFunction();
                    return { timeLeft: 0 };
                }
                return { timeLeft: Math.round(timeToStop / 1000) };
            });
        }, 1000);
    }

    componentWillUnmount() {
        if (this.timer) clearInterval(this.timer);
    }

    formatTime(seconds: number) {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
    }

    render() {
        return (
            <Navbar fixed="top" className="navbar-countdown justify-content-end">
                <Navbar.Text>
                    Time Left: {this.formatTime(this.state.timeLeft)}
                </Navbar.Text>
            </Navbar>
        );
    }
}

export default CountdownTimer;
